import { render, staticRenderFns } from "./CacheSystem.vue?vue&type=template&id=49f0acfc&scoped=true&"
import script from "./CacheSystem.vue?vue&type=script&lang=js&"
export * from "./CacheSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f0acfc",
  null
  
)

export default component.exports